// Parent-context hint encoded into URLs as `?from=policy:N` or `?from=agency:X`.
// Detail pages parse this to render a clickable breadcrumb trail back to the
// page the user drilled in from. The format is intentionally narrow: one
// parent context per URL, no chain serialization.

export type BreadcrumbFrom =
  | { kind: "policy"; policyNumber: string }
  | { kind: "agency"; agentNumber: string };

export function parseFrom(value: string | null | undefined): BreadcrumbFrom | null {
  if (!value) return null;
  const colon = value.indexOf(":");
  if (colon <= 0) return null;
  const kind = value.slice(0, colon);
  const id = value.slice(colon + 1);
  if (!id) return null;
  if (kind === "policy") return { kind: "policy", policyNumber: id };
  if (kind === "agency") return { kind: "agency", agentNumber: id };
  return null;
}

export function encodeFromPolicy(policyNumber: string): string {
  return `policy:${policyNumber}`;
}

export function encodeFromAgency(agentNumber: string): string {
  return `agency:${agentNumber}`;
}
